<template>
  <el-dialog
    title="选择客户"
    :visible.sync="visible"
    width="960px"
    append-to-body=""
    @closed="handleClosed">
    <div class="search-form">
      <el-input
        v-model="config.keyword"
        placeholder="请输入客户名称"
        style="width: 200px"
        clearable=""
        class="input-with-select">
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="handleCurrentChange(1)"></el-button>
      </el-input>
    </div>
    <el-table
      v-loading="loading"
      border
      highlight-current-row
      :data="list"
      @current-change="handleCurrentRowChange">
      <el-table-column
        label=""
        :resizable="false"
        width="30">
        <template slot-scope="{row}">
          <el-radio
            v-model="current.customerId"
            :label="row.customerId">&nbsp;</el-radio>
        </template>
      </el-table-column>
      <el-table-column
        :resizable="false"
        label="客户名称"
        prop="customerName"></el-table-column>
      <el-table-column
        :resizable="false"
        label="联系人"
        width="80"
        prop="contactMan"></el-table-column>
      <el-table-column
        :resizable="false"
        label="联系手机"
        width="100"
        prop="contactPhone"></el-table-column>
      <el-table-column
        :resizable="false"
        label="联系地址"
        prop="contactAddress"></el-table-column>
      <el-table-column
        width="230"
        :resizable="false"
        label="所属部门(公司)"
        prop="departmentName"></el-table-column>
    </el-table>
    <el-pagination
      background
      style="text-align: center;"
      :current-page="config.pageNum"
      :page-size="config.pageSize"
      layout="total, prev, pager, next"
      :total="totalNum"
      @current-change="handleCurrentChange">
    </el-pagination>
    <div slot="footer">
      <el-button @click="toggleModal(false)">取 消</el-button>
      <el-button
        type="primary"
        @click="add">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'CustomerSelectModal',
  components: {},
  props: {
    callback: Function,
    autoClose: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      loading: false,
      list: [],
      visible: false,
      config: {
        pageNum: 1,
        pageSize: 10,
        keyword: ''
      },
      options: {},
      totalNum: 0,
      current: {}
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.list = []
      this.totalNum = 0
      this.options = {}
      this.config.pageNum = 1
      this.config.keyword = ''
      this.current = {}
    },
    handleCurrentChange(cur) {
      this.config.pageNum = cur
      this.fetchList()
    },
    add() {
      if (!this.current.customerId) {
        this.$message.error('请选择一个客户')
        return
      }
      this.callback && this.callback(this.current)
      if (this.autoClose) {
        this.toggleModal(false)
      }
    },
    handleCurrentRowChange(row) {
      this.current = row || {}
    },
    fetchList(cb) {
      this.loading = true
      this.$store.dispatch('vendor/getcustomers', {
        payload: {
          ...this.config,
          ...this.options
        },
        success: res => {
          this.loading = false
          this.totalNum = res.data.total
          this.list = res.data.records
          cb && cb()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    fetch(options) {
      this.options = options
      this.fetchList(() => {
        this.toggleModal(true)
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
.search-form {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}
</style>
